var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"mt-16"},[_c('h1',{staticClass:"mb-4 font-semibold text-4xl"},[_vm._t("headline")],2),_c('p',{staticClass:"mb-8 text-gray-700"},[_vm._t("info-text")],2),_vm._t("progress-bar")],2)}
var staticRenderFns = []

export { render, staticRenderFns }